import { CommonModule } from "@angular/common";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { SharedModule } from "src/app/shared/shared.module";
import { UpsellFaqsComponent } from "src/components/upsell-faq/upsell-faq";
import { UpsellBannerComponent } from "src/components/upsell-banner/upsell-banner";
import { UpsellButtonsComponent } from "src/components/upsell-buttons/upsell-buttons";
import { BrandFooterComponent } from "src/components/brand-footer/brand-footer";
import { UpsellGuaranteeComponent } from "src/components/upsell-guarantee/upsell-guarantee";
import { BrandHeaderComponent } from "src/components/brand-header/brand-header";
import { UpsellMBGComponent } from "src/components/upsell-mbg/upsell-mbg";
import { UpsellModalComponent } from "src/components/upsell-modal/upsell-modal.component";
import { UpsellMultiSelectorComponent } from "src/components/upsell-multi-selector/upsell-multi-selector";
import { UpsellProductBoxComponent } from "src/components/upsell-product-box/upsell-product-box";
import { UpsellSectionComponent } from "src/components/upsell-section/upsell-section";
import { UpsellSliderComponent } from "src/components/upsell-slider/upsell-slider";
import { UpsellStickyBar } from "src/components/upsell-sticky-bar/upsell-sticky-bar";
import { UpsellWaitComponent } from "src/components/upsell-wait/upsell-wait";
import { UpsellWhyComponent } from "src/components/upsell-why/upsell-why";
import { VideoPlayerVidalyticsComponent } from 'src/components/video-player-vidalytics/video-player-vidalytics';

@NgModule({
  declarations: [
    UpsellBannerComponent,
    UpsellButtonsComponent,
    UpsellFaqsComponent,
    UpsellGuaranteeComponent,
    UpsellMBGComponent,
    UpsellModalComponent,
    UpsellMultiSelectorComponent,
    UpsellProductBoxComponent,
    UpsellSectionComponent,
    UpsellSliderComponent,
    UpsellStickyBar,
    UpsellWaitComponent,
    UpsellWhyComponent,
    VideoPlayerVidalyticsComponent,
  ],
  exports: [
    UpsellBannerComponent,
    UpsellButtonsComponent,
    UpsellFaqsComponent,
    BrandFooterComponent,
    UpsellGuaranteeComponent,
    BrandHeaderComponent,
    UpsellMBGComponent,
    UpsellModalComponent,
    UpsellMultiSelectorComponent,
    UpsellProductBoxComponent,
    UpsellSectionComponent,
    UpsellSliderComponent,
    UpsellStickyBar,
    UpsellWaitComponent,
    UpsellWhyComponent,
    VideoPlayerVidalyticsComponent,
  ],
  imports: [CommonModule, SharedModule, BrandHeaderComponent, BrandFooterComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class UpsellModule { }
